import { Firebase } from "@/app/core/base/FirebaseApp";
import { toast } from "react-toastify";
import {
  getFirestore,
  collection,
  getDocs,
  updateDoc,
  doc,
  getDoc,
  Timestamp,
  getCountFromServer,
  query,
  where,
  addDoc,
} from "firebase/firestore";
import { ErrorHelper } from "../../util/helpers/ErrorHelper";
import { FireHelper } from "../../util/helpers/FireHelper";
import { DateHelper } from "../../util/helpers/DateHelper";
import algoliasearch from "algoliasearch";

export const TimelineController = {
  db: getFirestore(Firebase),

  ToFirestoreCompany: function (data) {
    let updatedData = {
      complainId: data.complainId,
      id: data.id,
      description: data.description,

      createdDate: data.createdDate ?? Timestamp.now(),
      updatedDate: Timestamp.now(),
    };
    return FireHelper.ToFirestoreDoc(updatedData);
  },

  Insert: async function (data) {
    try {
      const coll = collection(this.db, "timeline");
      const result = await addDoc(coll, this.ToFirestoreCompany(data));
      return result.id;
    } catch (e) {
      console.log("TimelineController insert error", e);
      toast.error(ErrorHelper.HandleMessage(e));
      return null;
    }
  },

  List: async function (complainId) {
    try {
      const timelineCollection = collection(this.db, "timeline");
      const timelineQuery = query(timelineCollection, where("complainId", "==", complainId));
      const querySnapshot = await getDocs(timelineQuery);

      if (querySnapshot.empty) {
          console.log("No matching documents.");
          return [];
      }

      const results = querySnapshot.docs.map((doc) => ({
          ...doc.data(),
          id: doc.id,
      }));

      console.log("Results", results);
      return results;
  } catch (error) {
      console.error("Error fetching timeline:", error);
      return [];
  }
  },

  GetTotalCount: async function () {
    const coll = collection(this.db, "timeline");
    const snapshot = await getCountFromServer(coll);
    return snapshot.data().count;
  },
};
